module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Repositorios/FacturacionWeb/src/app/main/content/content.component.html
// module id = ../../../../../src/app/main/content/content.component.html
// module chunks = main